<app-back-to-integrations-button></app-back-to-integrations-button>
<div class="page-content">
	<div>
		<img src="/assets/images/integrations/teranet-logo.svg" />
	</div>
	<div>
		<h2>Teranet</h2>
		<p class="mt-5">
			Access the Electronic Land Registration and Writs databases right from
			within Closer to complete property and writs searches.
		</p>
		<div
			class="mb-0 mt-5 flex items-center"
			*ngIf="teranetUsername?.length > 0"
		>
			<div class="w-2 h-2 rounded-md bg-green mr-2"></div>
			<span>Connected</span>
		</div>
		<div class="flex mt-5">
			<app-button
				size="small"
				btn="secondary"
				class="mr-5"
				(click)="viewCredentials()"
				*ngIf="teranetUsername?.length > 0"
				>Validate Credentials</app-button
			>
			<app-button
				size="small"
				(click)="viewCredentials()"
				*ngIf="!teranetUsername || teranetUsername?.length === 0"
				>Connect</app-button
			>
		</div>

		<app-profile-benefits [benefits]="benefits"></app-profile-benefits>

		<ng-container *ngIf="teranetUsername">
			<div class="border-t-2 my-5 border-grey-lighter"></div>

			<h3>Account Setup</h3>
			<form
				(ngSubmit)="onSubmit(integrationsForm)"
				#integrationsForm="ngForm"
				class="flex flex-col"
			>
				<app-input
					label="Default Teranet account name"
					class="mt-2"
					[required]="true"
					[(ngModel)]="teranetAccountName"
					[name]="teranetFormValue"
					id="teranetFormValue"
				></app-input>

				<app-checkbox
					class="mt-5"
					type="clear"
					[ngModel]="showOverrides"
					(ngModelChange)="showOverrides = $event"
					[@openClose]
					name="showOverrides"
					>Set office specific Teranet account names</app-checkbox
				>

				<div *ngIf="showOverrides" [@openClose] class="pt-5">
					<ul>
						<li class="flex flex-1 gap-3">
							<div class="flex-1">Office</div>
							<div class="flex-1">Teranet Account</div>
						</li>
						<li
							*ngFor="let address of addresses; let i = index"
							class="grid grid-cols-2 items-center gap-3 mt-2"
						>
							<p class="font-bold">{{ address.officeName }}:</p>
							<app-input
								[(ngModel)]="address.teranetAccountName"
								[name]="'accountName' + i"
							></app-input>
						</li>
					</ul>
				</div>

				<app-button type="submit" btn="primary" class="mt-4 justify-end"
					>Save</app-button
				>
			</form>
		</ng-container>
	</div>
	<div>
		<app-container title="Resources" type="dark">
			<div class="text-sm">
				<app-anchor
					[icon]="ICON.EXTERNAL"
					[external]="true"
					url="https://my.teranetconnect.ca/registration/tvDesktopLogin.form"
					>Register for Teranet Connect</app-anchor
				>
				<app-anchor
					[icon]="ICON.EXTERNAL"
					[external]="true"
					url="http://www.teraview.ca/wp-content/uploads/2017/12/Transaction_Pricing_20171106.pdf"
					>Teranet Connect rate sheet</app-anchor
				>
				<app-anchor
					[icon]="ICON.EXTERNAL"
					[external]="true"
					url="https://my.teranetconnect.ca/registration/tvDesktopLogin.form"
					>My Teranet account</app-anchor
				>
			</div>
		</app-container>
	</div>
</div>
